import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Briefcase, CurrencyInr, Clock, BookmarkSimple, Bookmark } from "@phosphor-icons/react";
import { formatSalaryINR } from "../../lib/format";

export const JobCard = ({ job, onApply, onToggleSave, currentUser }) => {
    const salary = formatSalaryINR(job.salary_min, job.salary_max);

    const canSave = currentUser?.role === "seeker";
    const isSaved = !!job.is_saved;

    return (
        <div
            data-testid={`job-card-${job.job_id}`}
            className="border border-slate-200 bg-white p-5 hover:border-slate-950 transition-colors group"
        >
            <div className="flex items-start justify-between gap-4">
                <div className="flex-1 min-w-0">
                    <div className="font-mono-plex text-xs uppercase tracking-widest text-slate-500">
                        {job.company_name}
                    </div>
                    <Link
                        to={`/jobs/${job.job_id}`}
                        data-testid={`job-title-${job.job_id}`}
                        className="block font-display text-2xl leading-tight mt-1 hover:text-blue-600"
                    >
                        {job.title}
                    </Link>
                    <p className="text-sm text-slate-600 mt-2 line-clamp-2">
                        {job.description}
                    </p>
                    <div className="flex flex-wrap items-center gap-4 mt-4 text-xs text-slate-600">
                        <span className="inline-flex items-center gap-1">
                            <MapPin size={14} /> {job.location}
                        </span>
                        <span className="inline-flex items-center gap-1">
                            <Briefcase size={14} /> {job.job_type}
                        </span>
                        <span className="inline-flex items-center gap-1">
                            <CurrencyInr size={14} /> {salary}
                        </span>
                        {job.experience_required ? (
                            <span className="inline-flex items-center gap-1">
                                <Clock size={14} /> {job.experience_required}+ yrs
                            </span>
                        ) : null}
                    </div>
                    {job.skills?.length > 0 && (
                        <div className="flex flex-wrap gap-1.5 mt-4">
                            {job.skills.slice(0, 6).map((s) => (
                                <span
                                    key={s}
                                    className="text-xs px-2 py-0.5 border border-slate-300 font-mono-plex"
                                >
                                    {s}
                                </span>
                            ))}
                        </div>
                    )}
                </div>
                <div className="flex flex-col items-end gap-2">
                    {canSave && onToggleSave && (
                        <button
                            data-testid={`save-job-${job.job_id}`}
                            onClick={() => onToggleSave(job)}
                            aria-pressed={isSaved}
                            title={isSaved ? "Unsave" : "Save job"}
                            className={`text-sm px-3 py-1.5 inline-flex items-center gap-1.5 border ${
                                isSaved
                                    ? "bg-blue-50 border-blue-600 text-blue-700"
                                    : "border-slate-300 hover:border-slate-950"
                            }`}
                        >
                            {isSaved ? <BookmarkSimple size={14} weight="fill" /> : <Bookmark size={14} />}
                            {isSaved ? "Saved" : "Save"}
                        </button>
                    )}
                    <Link
                        to={`/jobs/${job.job_id}`}
                        data-testid={`view-job-${job.job_id}`}
                        className="text-sm px-3 py-1.5 border border-slate-300 hover:bg-slate-950 hover:text-white"
                    >
                        View
                    </Link>
                    {onApply && (
                        <button
                            data-testid={`apply-job-${job.job_id}`}
                            onClick={() => onApply(job)}
                            className="text-sm px-3 py-1.5 bg-blue-600 text-white hover:bg-slate-950"
                        >
                            Apply
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default JobCard;
